import { DialogProvider } from "./components/ui/Dialog/DialogProvider";

export const APP_START      	= 0x0100000;


export const DP = new DialogProvider();

export var SCREEN_WIDTH = {
    IS_SMALL: ()=>{ return window.innerWidth <= 560},
    IS_MEDIUM: ()=>{ return window.innerWidth > 560 && window.innerWidth <= 992},
    IS_LARGE: ()=>{ return window.innerWidth > 992}
}